module.exports = __webpack_public_path__ + "6787a91886dc338e6afccefb9919f930.svg";